import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var $: any, OpenSeadragon: any;
@Component({
  selector: 'app-img-view',
  templateUrl: './img-view.component.html',
  styleUrls: ['./img-view.component.css']
})
export class ImgViewComponent implements OnInit {
  // 图像路径
  @Input() resourcePath: string = '';
  // 是否只进行图像展示
  @Input() onlyView: boolean = true;
  // 版面分析数据
  @Input() layoutStr:string = '';
  // 进行框选操作后：抛出事件
  @Output() rectSelect = new EventEmitter();
  //OpenSeadragon对象
  viewer: any;       
  //OpenSeadragonHTMLelements            
  hEl: any;           
  // 新增字、版面分析区域框选对象
  selection:any;
  // 编辑版面分析区域框选对象
  selection1:any;
  // 当前正在编辑的版面分析区域
  currentLay:any;
  addEleIds:any = [];
  // 是否展示版面分析区域
  showAreaBox = false;
  // 版面分析区域数据
  layoutArr:any = [];
  bigImgUrl:string = '';
  // 判断当前框选操作类型  0：新增字、版面；1：编辑版面
  frameSelectType = 0;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }){
    // 快捷菜单
    if(changes['resourcePath']){
      if(this.resourcePath){
        this.init();
      }
    }
    else if(changes['layoutStr']){
      if(this.showAreaBox){
        this.drawAllLayout();
      }
    }
  }

  init(){
    this.bigImgUrl = this.getIiifImgUrl();
    $('#pic').empty();
    this.selection = null;
    this.selection1 = null;
    let that = this;
    // 展示大图
    this.viewer = OpenSeadragon({
      //装载到的容器id
      id: "pic",
      //指定库中按钮等图片所在文件夹
      prefixUrl: "./assets/Scripts/openseadragon/img/openseadragon-imgs/",
      //最小放大倍数
      minZoomLevel: 0.3,          
      //最大放大倍数
      maxZoomLevel: 16,   
      //sequenceMode设置为true,代表加载的是一张图片而非一个图片合集        
      sequenceMode: true,
      //是否显示全屏按钮
      showFullPageControl: false,
      //是否显示前进后退按钮
      showSequenceControl: false,
      //是否显示导航缩略图
      showNavigator: false,   
      //当鼠标移出图片区域时，是否自动隐藏导航视图和缩略图
      autoHideControls: false,  
      //鼠标事件设置
      gestureSettingsMouse: {            
        clickToZoom: 0,    //禁用默认点击放大功能
      },
      //所要显示的源图片信息
      tileSources: that.bigImgUrl+'info.json',
      timeout: 60000
    });
  
    //获取OpenSeadragonHTMLelements对象
    this.hEl = this.viewer.HTMLelements();
    if(!this.onlyView){
      //配置框选参数，定义添加标注功能
      const odOption = {
        allowRotation: false,         
        //定义确认当前选区后执行的方法
        onSelection: function (rect) {
          if(that.frameSelectType === 0 || that.selection.isSelecting){
            // 关闭框选功能
            that.selection.disable();
            that.addLayer(rect);
            // 向父组件发射框选的区域信息
            that.rectSelect.emit({
              bigImgUrl: that.bigImgUrl,
              rect: rect,
              operationState: 'add',
              operationType: ''
            });
          }
        },
        prefixUrl: null,    
        // 重写导航按钮图标文件
        navImages: {        
          selection: {
            REST: 'selection_rest.png',
            GROUP: 'selection_grouphover.png',
            HOVER: 'selection_hover.png',
            DOWN: 'selection_pressed.png'
          },
          selectionConfirm: {
            REST: 'selection_confirm_rest.png',
            GROUP: 'selection_confirm_grouphover.png',
            HOVER: 'selection_confirm_hover.png',
            DOWN: 'selection_confirm_pressed.png'
          },
          selectionCancel: {
            REST: 'selection_cancel_rest.png',
            GROUP: 'selection_cancel_grouphover.png',
            HOVER: 'selection_cancel_hover.png',
            DOWN: 'selection_cancel_pressed.png'
          }
        }
      };
      this.selection = this.viewer.selection(odOption);
    }
  
    // 监听打开图片操作
    this.viewer.addHandler("open", () => {
      // 设置图片默认宽度或高度占满展示
      this.viewer.viewport.fitVertically();
      if(this.onlyView){
        // 按钮隐藏
        $('div[title="Zoom in"]').hide();
        $('div[title="Zoom out"]').hide();
        $('div[title="Go home"]').hide();
      }else{
        // 按钮提示信息汉化
        $('div[title="Zoom in"]').attr('title', '放大');
        $('div[title="Zoom out"]').attr('title', '缩小');
        $('div[title="Go home"]').attr('title', '返回主位置');
        $('div[title="Toggle selection"]').attr('title', '切换框选功能');
        $('.toggleAreaBtn').css('opacity',1);
      }
      // 绘制版面分析区域
      if(this.layoutStr && this.showAreaBox){
        this.drawAllLayout();
      }
      // 绑定按钮组点击事件
      this.onPicButtonsClick();
    });

    // 对OpenSeadragon.Viewer#canvas element添加单击事件
    this.viewer.addHandler('canvas-click', function(event) {
      let webPoint = event.position;
      let viewportPoint = that.viewer.viewport.pointFromPixel(webPoint);
      let imagePoint = that.viewer.viewport.viewportToImageCoordinates(viewportPoint);
      console.log(imagePoint);
    });
  }

  // 绑定按钮组点击事件
  onPicButtonsClick(){
    const that = this;
    //自定义切换框选模式功能
    $('.toggleAreaBtn').unbind('click').click(function () {
      //判断当前是否处于框选区域状态
      if (that.showAreaBox) {
        $(this).find('img.notSelected').show();
        $(this).find('img.selected').hide();
        that.showAreaBox = false;
        that.removeAllArea();
      } else {
        $(this).find('img.notSelected').hide();
        $(this).find('img.selected').show();
        that.showAreaBox = true;
        that.drawAllLayout();
      }
    });
  }

  // 绘制版面分析区域
  drawAllLayout(){
    this.removeAllArea();
    const layoutArr = JSON.parse(this.layoutStr);
    layoutArr.forEach((item,index) => {
      // {
      //   "type": "text",
      //   "bbox": [604, 280, 642, 371]
      // }
      const id = item.type+''+index;
      item['id'] = id;
      const rect = {
        x: parseFloat(item.bbox[0]),
        y: parseFloat(item.bbox[1]),
        width: parseFloat(item.bbox[2]) - parseFloat(item.bbox[0]),
        height: parseFloat(item.bbox[3]) - parseFloat(item.bbox[1]),
        type: item.type,
        id: id
      };
      this.addLayout(rect,index);
    });
    this.layoutArr = layoutArr;
    //保存之后默认将缩放比例添加0.0001，使标注显示
    const zoom = this.viewer.viewport.getZoom();
    this.viewer.viewport.zoomTo(zoom + 0.0001);
  }

  // 清除版面分析区域
  removeAllArea(){
    if(this.layoutArr.length>0){
      // 移除之前绘制的标注
      for (let i = 0; i < this.layoutArr.length; i++) {
        const item = this.layoutArr[i];
        if(this.hEl.getElementById('layout-'+item.id)){
          this.hEl.removeElementById('layout-'+item.id);
        }
      }
      this.layoutArr = [];
    }
  }

  //添加版面分析区域
  addLayout(rect,index){
    const markElement = document.createElement("div");
    const id = 'layout-'+rect.id;
    // 当前为新增标注或修改标注区域图操作时需添加编辑中样式
    markElement.className = 'layoutOverlay';
    markElement.id = id;
    const ele = {
      id: id,
      element: markElement,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    };
    this.hEl.addElement(ele);
    let divEle = this.hEl.getElementById(id).element.getElementsByClassName('layoutOverlay')[0];
    const typeName = this.getTypeName(rect.type);
    divEle.innerHTML = '<div class="box '+rect.type+'"><span>'+typeName+'</span></div>';
    const that = this;
    // 给已绘制的版面分析区域绑定点击事件
    divEle.getElementsByClassName('box')[0].onclick = function () {
      that.frameSelectType = 1;
      that.selection.disable();
      if(that.selection1){
        that.selection1.disable();
      }
      that.currentLay = {
        index: index,
        type: rect.type
      }
      let oRect = new OpenSeadragon.Rect(rect.x, rect.y, rect.width, rect.height, 0);
      oRect = that.viewer.viewport.imageToViewportRectangle(oRect);
      oRect = new OpenSeadragon.SelectionRect(oRect.x, oRect.y, oRect.width, oRect.height, oRect.degrees);
      if(that.selection1){
        that.selection1 = that.viewer.selection(
          {   
            allowRotation: false,    
            showSelectionControl:false,  // 不展示切换按钮 
            rect:oRect
          }
        );
        that.selection1.enable();
        return;
      }
      that.selection1 = that.viewer.selection(
        {
          allowRotation: false,    
          showSelectionControl:false,  // 不展示切换按钮   
          rect:oRect,  
          //定义确认当前选区后执行的方法
          onSelection: function (rect1) {
            if(that.frameSelectType === 1 && !that.selection.isSelecting){
              rect1.type = that.currentLay.type;
              that.rectSelect.emit({
                bigImgUrl: that.bigImgUrl,
                rect: rect1,
                index: that.currentLay.index,
                operationState: 'edit',
                operationType: 'area'
              });
              that.selection1.disable();
              that.frameSelectType = 0;
            }
          },
          onSelectionCancel: function(rect1){
            that.selection1.disable();
            that.frameSelectType = 0;
          },
          prefixUrl: null,    
          // 重写导航按钮图标文件
          navImages: {
            selectionConfirm: {
              REST: 'selection_confirm_rest.png',
              GROUP: 'selection_confirm_grouphover.png',
              HOVER: 'selection_confirm_hover.png',
              DOWN: 'selection_confirm_pressed.png'
            },
            selectionCancel: {
              REST: 'selection_cancel_rest.png',
              GROUP: 'selection_cancel_grouphover.png',
              HOVER: 'selection_cancel_hover.png',
              DOWN: 'selection_cancel_pressed.png'
            }
          }
        }
      );
      that.selection1.enable();
    }
  }

  // 根据版面分析code获取对应的分类名称
  getTypeName(type){
    switch(type){
      case 'header': return '页眉';
      case 'footer': return '页脚';
      case 'text': return '正文';
      case 'note': return '注释';
      case 'middleSeam': return '中缝';
      default: return '';
    }
  }

  //添加矩形标注及标注文字,返回值为添加的标注的id属性
  addLayer(rect: any) {
    this.clearEles();
    const markElement = document.createElement("div");
    const id = 'mark_current';
    // 当前为新增标注或修改标注区域图操作时需添加编辑中样式
    markElement.className = 'markOverlay';
    markElement.id = id;
    const ele = {
      id: id,
      element: markElement,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    };
    this.hEl.addElement(ele);
    this.addEleIds.push(id);
    let divEle = this.hEl.getElementById(id).element.getElementsByClassName('markOverlay')[0];
    divEle.innerHTML = '<div class="box"></div>';
    // 框选之后默认将缩放比例添加0.0001，使标注显示
    const zoom = this.viewer.viewport.getZoom();
    this.viewer.viewport.zoomTo(zoom + 0.0001);
  }

  // 清除标记
  clearEles(){
    if(this.addEleIds.length>0){
      this.addEleIds.forEach(el => {
        if(this.hEl.getElementById(el)){
          this.hEl.removeElementById(el);
        }
      });
      this.addEleIds = [];
    }
  }

  //拼接大图展示地址
  getIiifImgUrl(){
    if(!this.resourcePath){
      return '';
    }
    const url = this.resourcePath;
    const pathArr = url.split('/');
    let res = environment.iiifImgUrl;
    for(let i=0;i<pathArr.length;i++){
      res += (i == pathArr.length -1 ? pathArr[i] + '/' : pathArr[i]+'%2F');
    }
    return res;
  }
}
